<template>
  <div class="container">
    <ion-list lines="none" class="outlet-list">
      <ion-item v-for="(value, key) in outlets" :key="key" class="outlet-item" button detail="false">
        <ion-avatar slot="start" class="custom-avatar">
          <img :src="value['receipt_logo']" @error="handleImageError">
        </ion-avatar>

        <ion-label class="outlet-content">
          <router-link class="link-wrapper" :to="{ name: 'home', params: { id: value['outlet_id'] } }">
            <h2 class="outlet-name">{{ value['name'] }}</h2>
            <p class="outlet-address">
              <ion-icon name="location-outline" class="mini-icon"></ion-icon>
              {{ value['address'] }}
            </p>
          </router-link>
        </ion-label>

        <ion-icon name="chevron-forward-outline" slot="end" color="medium"></ion-icon>
      </ion-item>
    </ion-list>
  </div>
</template>

<script>
import { chevronForwardOutline, locationOutline } from 'ionicons/icons';

export default {
  name: 'homePages',
  props: ['outlets'],
  setup() {
    return { chevronForwardOutline, locationOutline };
  },
  methods: {
    handleImageError(e) {
      // Fallback jika gambar logo tidak ditemukan
      e.target.src = 'https://placehold.co/150?text=No+Logo';
    }
  }
}
</script>

<style scoped>
.container {
  padding: 10px;
  background-color: #f8f9fa;
  /* Background soft */
}

.outlet-list {
  background: transparent;
}

.outlet-item {
  --background: #ffffff;
  --padding-start: 12px;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --border-radius: 16px;
  /* Membuat sudut membulat */
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  /* Shadow halus */
  transition: transform 0.2s ease;
}

.outlet-item:active {
  transform: scale(0.98);
  /* Efek klik membal */
}

.custom-avatar {
  width: 56px;
  height: 56px;
  border: 2px solid #f0f0f0;
}

.link-wrapper {
  text-decoration: none;
  display: block;
}

.outlet-name {
  font-weight: 700 !important;
  font-size: 1.1rem !important;
  color: #2c3e50;
  margin-bottom: 4px;
}

.outlet-address {
  font-size: 0.85rem;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  margin: 0;
}

.mini-icon {
  margin-right: 4px;
  font-size: 1rem;
}

/* Animasi list masuk */
.outlet-item {
  animation: slideUp 0.4s ease forwards;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>